// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { wishListCardStyles } from "@rpsc/Overrides/Components/WishListCard";
import IconTag from "@rpsc/XDL/Icons/IconTag";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { ellipsis, moreActionsSharedStyle, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

wishListCardStyles.container = {
    css: css`
        width: 100%;
        display: grid;
        grid-template-columns: minmax(0, 1fr) max(317px) minmax(65px, 0.5fr) max(141px);
        grid-column-gap: 22px;
        grid-row-gap: 12px;
        justify-content: space-between;
        ${xScreen("gte", "xl")} {
            grid-template-columns: minmax(317px, 376px) minmax(317px, 377px) minmax(95px, 376px) max(141px);
        }
        ${xScreen("lte", "md")} {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    `,
};

wishListCardStyles.descriptionWrapper = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 2;

        > div {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    `,
};

wishListCardStyles.nameWrapper = {
    css: css`
        & > ${StyledButton} {
            font-weight: ${fontConfig.weight.bold};
            ${TypographyStyle} {
                font-size: 16px;
                line-height: 22px;
                ${ellipsis(2)}
            }
        }
    `,
};

wishListCardStyles.lastUpdatedText = {
    size: 12,
    lineHeight: "17px",
};

wishListCardStyles.descriptionText = {
    size: 12,
    lineHeight: "17px",
    css: css`
        ${ellipsis(2)}
    `,
};

wishListCardStyles.favTagsWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        flex-wrap: wrap;
        row-gap: 8px;
    `,
};

wishListCardStyles.tagTooltip = {
    mergeCss: true,
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

wishListCardStyles.detailIconWrapper = {
    css: css`
        display: flex;
        ${TypographyStyle} {
            line-height: 17px;
        }
    `,
};

wishListCardStyles.tagIcon = {
    icon: {
        iconProps: {
            src: IconTag,
            size: 13,
        },
    },
    typographyProps: {
        css: css`
            margin-left: 6px;
        `,
    },
};

wishListCardStyles.imagesWrapper = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: 22px;
        justify-self: flex-start;
        ${xScreen("lte", "md")} {
            gap: 20px;
        }
    `,
};

wishListCardStyles.productImageLink = {
    css: css`
        display: flex;
        align-items: flex-start;
        margin: 0;
    `,
};

wishListCardStyles.productImage = {
    mergeCss: true,
    css: css`
        width: 91px;
        height: 91px;

        ${xScreen("gte", "xl")} {
            width: 111px;
            height: 111px;
        }
        ${xScreen("lte", "md")} {
            width: 148px;
            height: 148px;
        }
        ${xScreen("lte", "sm")} {
            width: 96px;
            height: 96px;
        }

        img {
            width: 100%;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
        }
    `,
};

wishListCardStyles.sharingStatusWrapper = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 2;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 8px;
    `,
};

wishListCardStyles.actionsWrapper = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            margin-top: 4px;
        }
    `,
};

wishListCardStyles.actionGridMediumHidden = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
    `,
};

wishListCardStyles.overflowMenu = {
    ...moreActionsSharedStyle.overflowMenu,
};

wishListCardStyles.moreActions = {
    ...moreActionsSharedStyle.moreActionsLink,
};

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    sizeVariant: "medium",
    css: css`
        max-width: fit-content;
        white-space: nowrap;
    `,
};
